// Subscription plans
export const SUBSCRIPTION_PLANS = {
    FREE: 'Free',
    STARTER: 'Starter',
    GROWTH: 'Growth',
    ENTERPRISE: 'Enterprise',
    INDIVIDUAL: 'Individual',
};
